import { Component, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
})
export class AuthComponent implements OnInit, OnDestroy {
  constructor() {}

  ngOnInit() {
    document.getElementsByClassName('layout-container')[0].classList.add('laptopBackground');
  }

  ngOnDestroy() {
    document.getElementsByClassName('layout-container')[0].classList.remove('laptopBackground');
  }
}
